<template>
  <div class="container-fluid">

    <h5>گزارش توقف های تولید در کل شرکت</h5>

    <b-tabs justified
            active-nav-item-class="font-weight-bold text-success"
            active-tab-class="font-weight-bold"
            content-class=""
            class="mt-3"
    >
      <!--------first tab------->
      <b-tab title="توقفهای حال حاضر کل کارگاهها" active>
        <div v-if="isLoading">
          <Preloader/>
        </div>
        <div v-else>
          <div class="row my-4">
            <div class="col-12 mt-3" v-if="nodata">
              <h3>
                در حال حاضر هیچ وقفه ای در کل شرکت گزارش نشده است.
              </h3>
            </div>
            <div class="col-12 mt-3" v-else>
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col" class="text-center">نام محصول</th>
                  <th scope="col" class="text-center">نام کارگاه</th>
                  <th scope="col" class="text-center">نوع توقف</th>
                  <th scope="col" class="text-center">شرح توقف</th>
                  <th scope="col" class="text-center">کد کار</th>
                  <th scope="col" class="text-center">ساعات توقف</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in currentProblems">
                  <td class="text-center">{{item.productName}}</td>
                  <td class="text-center">{{item.companyName}}</td>
                  <td class="text-center">{{item.typeName}}</td>
                  <td class="text-center">{{item.problemName}} : {{item.problemDescription}}</td>
                  <td class="text-center">{{item.workCode}}</td>
                  <td class="text-center">{{item.hoursInStatus}}</td>

                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-tab>
      <!--------first tab------->
      <b-tab title="سابقه توقفهای تولید">
        <div class="row my-4">
          <div class="col-12 mt-3" v-if="nodata1">
            <h3>
              هیچ وقفه ای در کل شرکت گزارش نشده است.
            </h3>
          </div>
          <div class="col-12 mt-3" v-else>
            <div class="col-12 mt-3 d-inline-flex">
              <div class="col-6">
                <div class="input-group">
                  <div class="input-group-prepend custom">
                    <div class="input-group-text">
                      <span>نوع وقفه : </span>
                    </div>
                  </div>
                  <vs-select
                    ref="selectedProgram"
                    :isHeader="true"
                    :data="problemTypes"
                    :selectedVal="problemTypes.id"
                    :header="{label:'name'}"
                    :mode="'edit'"
                    @dataChanged="problemTypeSelect"
                    aria-placeholder="لطفا نوع وقفه را انتخاب کنید"
                  ></vs-select>
                  <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
                </div>
              </div>
              <div class="col-6" v-if="selectedProblemType !== 0">
                <div class="input-group">
                  <div class="input-group-prepend custom">
                    <div class="input-group-text">
                      <span>وقفه : </span>
                    </div>
                  </div>
                  <vs-select
                    ref="selectedProgram"
                    :isHeader="true"
                    :data="problemDetails"
                    :selectedVal="problemDetails.id"
                    :header="{label:'name'}"
                    :mode="'edit'"
                    @dataChanged="problemSelect"
                    aria-placeholder="لطفا وقفه را انتخاب کنید"
                  ></vs-select>
                  <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col" class="text-center">نام محصول</th>
                  <th scope="col" class="text-center">نام کارگاه</th>
                  <th scope="col" class="text-center">نوع توقف</th>
                  <th scope="col" class="text-center">شرح توقف</th>
                  <th scope="col" class="text-center">کد کار</th>
                  <th scope="col" class="text-center">ساعات توقف</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in totalProblems">
                  <td class="text-center">{{item.productName}}</td>
                  <td class="text-center">{{item.companyName}}</td>
                  <td class="text-center">{{item.typeName}}</td>
                  <td class="text-center">{{item.problemName}} : {{item.problemDescription}}</td>
                  <td class="text-center">{{item.workCode}}</td>
                  <td class="text-center">{{item.hoursInStatus}}</td>

                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </b-tab>

      <!--------first tab------->
      <b-tab title="گزارش بر اساس نوع وقفه">
        <div class="row my-4">
          <!--<div class="col-12 mt-3" v-if="nodata2">-->
          <!--<h3>-->
          <!--هیچ وقفه ای در کل شرکت گزارش نشده است.-->
          <!--</h3>-->
          <!--</div>-->
          <!--<div class="col-12 mt-3" v-else>-->

          <div class="col-lg-12 col-sm-12 my-2">
            <div class="card shadow text-white  mb-1">
              <div class="card-body pb-0">
                <div class="card-chart">
                  <canvas id="barchart1" width="1000" height="555"></canvas>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!--</div>-->
      </b-tab>

      <!--------first tab------->
      <b-tab title="گزارش بر اساس زمان توقفها">
        <div class="row my-4">
          <!--<div class="col-12 mt-3" v-if="nodata2">-->
          <!--<h3>-->
          <!--هیچ وقفه ای در کل شرکت گزارش نشده است.-->
          <!--</h3>-->
          <!--</div>-->
          <!--<div class="col-12 mt-3" v-else>-->

          <div class="col-lg-12 col-sm-12 my-2">
            <div class="card shadow text-white  mb-1">
              <div class="card-body pb-0">
                <div class="card-chart">
                  <canvas id="barchart3" width="1000" height="555"></canvas>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!--</div>-->
      </b-tab>

    </b-tabs>

    <!-------------------------------------------------------------------------------->

  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Products from "../Products.vue";
  import chart from "chart.js";
  import VsSelect from "../../_framework/VsSelect";
  import ShowProblemsModal from "../../components/ShowProblemsModal";
  import ProblemDetails from "../../components/ProblemDetails.vue";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Utils from "../../_framework/utils/Utils";
  import Moment from "moment-jalali";
  import VsTableHeaderRow from "../../_framework/VsTableHeaderRow";


  export default {
    name: "workreport-problem",
    created: () => {
    },
    components: {
      VsTableHeaderRow,
      VsTable,
      Products,
      VsSelect,
    },
    data() {
      return {
        isLoading: false,
        bar_chart: "bar-chart",
        show: true,
        nodata: true,
        nodata1: true,
        nodata2: true,
        access: {},
        products: {},
        productQuantity: {},
        productName: "",
        unitName: "",
        productId: "",
        rawproductQuantity: {},
        rawproducts: {},
        backgroundColor: ["#facf5a8f", "#ff59598f", "#49beb78f", "#a374d58f", "#5d99c68f", "#9cf1968f"],
        hoverBackgroundColor: ['#facf5ab5', '#ff5959b5', '#49beb7b5', '#a374d5b5', '#5d99c6b5', '#9cf196b5'],
        currentProblems: {},
        totalProblems: {},
        typeProblems: {},
        problemTypes: [],
        problemDetails: [],
        selectedProblemType: 0,
        selectedProblemId: 0,
        problemNameChart: [],
        problemTime: [],


      };
    },
    beforeMount() {
      this.getcurrentProblems();
      this.gettotalProblems();
      this.getProblemTypes();

      this.isLoading = true;
      new BaseService('WorksReports', '/GetTotalProblemWorksChart').getList().then((response) => {
        this.isLoading = false;
        if (response.data === null) {
          this.nodata2 = true;
        } else {
          this.nodata2 = false;
          this.typeProblems = response.data;

          this.gettypeProblems();
        }
      }).catch((error) => {
        this.isLoading = false;
        console.log(error)
      });
    },
    methods: {
      getcurrentProblems() {
        new BaseService('WorksReports', '/GetProblemWorks').getList().then((response) => {
          if (response.data === null) {
            this.nodata = true;
          } else {
            this.nodata = false;
            this.currentProblems = response.data;


          }
        }).catch((error) => {
          console.log(error)
        });
      },
      gettotalProblems() {
        new BaseService('WorksReports', '/GetTotalProblemWorks').getList().then((response) => {
          if (response.data === null) {
            this.nodata1 = true;
          } else {
            this.nodata1 = false;
            this.totalProblems = response.data;


          }
        }).catch((error) => {
          console.log(error)
        });
      },
      getSelectedProblems(id) {
        new BaseService('WorksReports', '/GetSelectedProblemWorks/' + id).getList().then((response) => {
          if (response.data === null) {
            this.nodata1 = true;
          } else {
            this.nodata1 = false;
            this.totalProblems = response.data;


          }
        }).catch((error) => {
          console.log(error)
        });
      },
      hideModal() {
        this.$refs.selectProductModal.hide();
      },
      getProblemTypes() {
        new BaseService('WorkProblems', '/GetProblemTypes').getList().then((response) => {
          // console.log(response.data);
          this.problemTypes = response.data;
          if (response.data !== null) {
            let data = {
              id: 0,
              name: "مشاهده تمام توقفها"
            };
            this.problemTypes.push(data);
            // console.log(this.problemTypes)
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      getProblems(id) {
        new BaseService('WorkProblems', '/GetProblemsByTypeId/' + id).getList().then((response) => {
          // console.log(response.data);
          this.problemDetails = response.data;
        }).catch((error) => {
          console.log(error)
        })
      },
      problemTypeSelect(prop, data) {
        // console.log(data);
        // console.log(data.programId);
        if (data.id == 0) {
          this.gettotalProblems();
        } else {
          this.selectedProblemType = data.id;
          this.getProblems(data.id);
        }
      },
      problemSelect(prop, data) {
        // console.log(data);
        // console.log(data.programId);
        this.selectedProblemId = data.id;
        this.getSelectedProblems(data.id);
      },


      gettypeProblems() {

        var dataName = [];
        var dataCompany = [];
        var dataHours = [];
        var dataCount = [];
        for (let problem of this.typeProblems) {
          this.problemNameChart.push(problem.problemName);
          dataName.push(problem.problemDescription);
          dataCompany.push(problem.totalCompany);
          dataHours.push(problem.totalHoursInStatus);
          dataCount.push(problem.totalCount);
        }

        Chart.defaults.global.defaultFontFamily = 'shabnam';
        this.polar = new Chart(document.getElementById("barchart1").getContext('2d'), {

          type: 'bar',
          data: {
            labels: dataName,
            datasets: [
              {
                label: 'تعداد کارگاه',
                data: dataCompany,
                backgroundColor: 'rgba(255,193,7,0.71)',
                borderColor: "rgba(255,143,0,0.71)"
              },
              {
                label: 'تعداد کار',
                data: dataCount,
                backgroundColor: 'rgba(249,60,103,0.71)',
                borderColor: "rgba(198,40,40,0.71)"
              },
              // {
              //   label: 'ساعات توقف',
              //   data: dataHours,
              //   backgroundColor: 'rgba(205,220,57,0.71)',
              //   borderColor: "rgba(135,150,40,0.71)"
              // }
            ]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100]
              }
            },
            title: {
              display: true,
              text: 'توقفهای تولید'
            },
          }

        });

        Chart.defaults.global.defaultFontFamily = 'shabnam';
        this.polar = new Chart(document.getElementById("barchart3").getContext('2d'), {

          type: 'bar',
          data: {
            labels: dataName,
            datasets: [
              {
                label: 'تعداد کارگاه',
                data: dataCompany,
                backgroundColor: 'rgba(255,193,7,0.71)',
                borderColor: "rgba(255,143,0,0.71)"
              },
              // {
              //   label: 'تعداد کار',
              //   data: dataCount,
              //   backgroundColor: 'rgba(249,60,103,0.71)',
              //   borderColor: "rgba(198,40,40,0.71)"
              // },
              {
                label: 'ساعات توقف',
                data: dataHours,
                backgroundColor: 'rgba(249,60,103,0.71)',
                borderColor: "rgba(198,40,40,0.71)"
              }
            ]
          },
          options: {
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100]
              }
            },
            title: {
              display: true,
              text: 'مجموع ساعات توقف'
            },
          }

        });


      },


    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"])
    }
  };
</script>
